export const HIDE_POPUP_SIGNAL = 'hideFullscreenPopup';
export const EXIT_APP_SIGNAL = 'exitApp';
export const ROUTE_BACK_SIGNAL = 'routeBack';
